import React, { useState } from "react";
import { useOutletContext } from "react-router";

import { SettingContainer } from "../styled/groupDetails";

import TabMenu from "../common/tabMenu";
import EditProfile from "./setting/editProfile";
import EditGroup from "./setting/editGroup";
import Members from "./setting/members";
import InviteModal from "./members/inviteModal";
import Membership from "./setting/membership";
import DeleteGroup from "./setting/deleteGroup";
import Withdrawal from "./setting/withdrawal";
import { useModal } from "../../../../hooks/useModal";

const GroupSetting = () => {
  const { modal, openModal, closeModal } = useModal();
  const { member, members, group, getGroupDetail, getGroupMembers } = useOutletContext();

  const [view, setView] = useState(0);
  const [isInvite, setIsInvite] = useState(false);

  const tabs = [
    { label: "프로필 변경", key: "editProfile" },
    { label: "모임 변경", key: "editGroup" },
    { label: "멤버 관리", key: "members" },
    { label: "가입 승인 관리", key: "membership" },
    member?.auth === 0
      ? { label: "모임 삭제", key: "deleteGroup" }
      : { label: "모임 탈퇴", key: "withdrawal" },
  ];

  const tabChange = (idx) => {
    setView(idx);
  };

  const Components = ({ index }) => {
    const commonProps = { openModal, closeModal };

    return [
      <EditProfile
        {...commonProps}
        member={member}
        group={group}
        getGroupMembers={getGroupMembers}
      />,
      <EditGroup {...commonProps} group={group} getGroupDetail={getGroupDetail} />,
      <Members
        {...commonProps}
        member={member}
        members={members}
        group={group}
        getGroupMembers={getGroupMembers}
        setIsInvite={setIsInvite}
      />,
      <Membership
        {...commonProps}
        group={group}
        members={members}
        getGroupMember={getGroupMembers}
      />,
      member?.auth === 0 ? (
        <DeleteGroup {...commonProps} group={group} getGroupDetail={getGroupDetail} />
      ) : (
        <Withdrawal {...commonProps} member={member} />
      ),
    ][index];
  };

  return (
    <>
      {modal}
      <SettingContainer>
        {isInvite && <InviteModal members={members} setIsInvite={setIsInvite} group={group} />}
        <TabMenu tabChange={tabChange} tabs={tabs} active={view} />
        <div className="content">{<Components index={view} />}</div>
      </SettingContainer>
    </>
  );
};

export default GroupSetting;
